import React from 'react';
import { STAT_LABELS } from './constants';

export default function RadarChart({ stats, size = 160, color = '#d4a574', labels: customLabels }) {
  const lbls = customLabels || STAT_LABELS;
  const pad = size * 0.18;
  const full = size + pad * 2;
  const cx = full / 2;
  const cy = full / 2;
  const r = size * 0.38;
  const levels = 3;
  const n = lbls.length;
  const angleSlice = (2 * Math.PI) / n;
  const startAngle = -Math.PI / 2;

  const point = (i, ratio) => {
    const a = startAngle + i * angleSlice;
    return [cx + r * ratio * Math.cos(a), cy + r * ratio * Math.sin(a)];
  };

  const gridLines = [];
  for (let lv = 1; lv <= levels; lv++) {
    const pts = Array.from({ length: n }, (_, i) => point(i, lv / levels).join(',')).join(' ');
    gridLines.push(<polygon key={lv} points={pts} fill="none" stroke="rgba(255,255,255,.08)" strokeWidth={0.5} />);
  }

  const axes = Array.from({ length: n }, (_, i) => {
    const [px, py] = point(i, 1);
    return <line key={i} x1={cx} y1={cy} x2={px} y2={py} stroke="rgba(255,255,255,.06)" strokeWidth={0.5} />;
  });

  const dataPts = stats.map((v, i) => point(i, v / 100).join(',')).join(' ');

  const labels = lbls.map((label, i) => {
    const [lx, ly] = point(i, 1.32);
    return (
      <text key={i} x={lx} y={ly} textAnchor="middle" dominantBaseline="central"
        fill="rgba(255,255,255,.55)" fontSize={full * 0.058} fontWeight="600" fontFamily="system-ui">
        {label}
      </text>
    );
  });

  return (
    <svg viewBox={`0 0 ${full} ${full}`} width={size} height={size} overflow="visible">
      {gridLines}
      {axes}
      <polygon points={dataPts} fill={`${color}22`} stroke={color} strokeWidth={1.2} strokeLinejoin="round" />
      {stats.map((v, i) => {
        const [dx, dy] = point(i, v / 100);
        return <circle key={i} cx={dx} cy={dy} r={1.8} fill={color} />;
      })}
      {labels}
    </svg>
  );
}
